import React, { useEffect, useLayoutEffect, useState, useRef } from 'react';
import { Button} from 'antd';
import MathJaxHTMLContent from '../common/MathJaxHTMLContent';
import CircularLoader from "../common/CircularLoader";
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

const QuestionFeedback = ({ result, onContinue, onNextQuestion }) => {
    const isCorrect = result.result;
    const feedbackRegionRef = useRef();

    useLayoutEffect(() => {
        if (feedbackRegionRef.current) {
            const button = feedbackRegionRef.current.querySelector('button');
            if (button) {
                button.focus();
            } else {
                feedbackRegionRef.current.focus();
            }
        }
    }, [result]);

    return (
        <div
            ref={feedbackRegionRef}
            tabIndex="-1"
            className="ch-feedback-callout"
            role="alert"
            aria-label={isCorrect ? "Correct answer" : "Incorrect answer"}
        >
            <div className="ch-feedback-header">
                {isCorrect ? (
                    <CheckCircleOutlined className="ch-feedback-icon" aria-hidden="true"/>
                ) : (
                    <CloseCircleOutlined className="ch-feedback-icon" aria-hidden="true"/>
                )}
                <h3 className="ch-feedback-title">{isCorrect ? 'Correct' : 'Incorrect'}</h3>
            </div>

            <div className="ch-feedback-body">
                {result.feedback && (
                    <MathJaxHTMLContent showLoader={false} html={result.feedback} />
                )}
            </div>

            <div className="ch-feedback-actions">
                {result?.repeat ? (
                    <>
                        <Button
                            type="primary"
                            onClick={onNextQuestion}
                        >
                            Next question
                        </Button>
                    </>
                ) : (
                    <Button
                        type="primary"
                        onClick={onContinue}
                    >
                        Continue
                    </Button>
                )}
            </div>
        </div>
    );
};

export default QuestionFeedback;